module.exports = __webpack_public_path__ + "static/media/mati.c5a1a600.svg";